<template>
    <div class="bg-wrap-color" v-loading="mixinLoading">
        <template v-if="isPageAllowed">
            <div class="tab-bar">
                <el-tabs v-model="pageActiveName" :before-leave="beforeChangeTab">
                    <el-tab-pane 
                        v-for="page in pageAction"
                        :key="page.name"
                        :label="page.display_name" 
                        :name="page.name"
                    />
                </el-tabs>
            </div>
            
            <div class="pl10 pr10">
                <component 
                    :is="componentPage"
                    :pageFuncNames="pageFuncNames"
                />
            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>素材比对</p>
            </NoPermissionInfo>
        </template>    
    </div>
</template>

<script>
import NoPermissionInfo from '@/components/noPermissionInfo';
import {pageMixin} from '../../mixins/pageMixin';
import MaterialComparePage from './page/diff'

export default {
    name: 'MaterialCompare',
    components: { NoPermissionInfo },
    mixins: [ pageMixin ],
    data() {
        return {
            pageActiveName: '',
        }
    },
    computed: {
        componentPage() {
            const page = {
                material_compare_page: MaterialComparePage,//比对管理
            };
            
            return page[this.pageActiveName] || null;
        }
    },
    created() {
        this.pageActiveName = this.$route.name;
    },
    methods: {
        initPageStates() {
            this.pageActiveName = this.$route.name
        },
        beforeChangeTab(newName){
            this.pageActiveName = newName;
            this.$router.push(this.pageActiveName);
        },
    }
}
</script>

<style lang="scss" scoped>
.tab-bar::after{
    content: '';
    position: absolute;
    left: -20px;
    right: -20px;
    background-color: #fff;
}
.tab-bar ::v-deep .el-tabs__header{
    background-color: #fff;
    margin-bottom: 10px;
    .el-tabs__nav-wrap{
        padding-left: 30px;
    }
    .el-tabs__active-bar {
        min-width: 56px;
    }
}
.tab-bar ::v-deep .el-tab-pane{
    margin: 0 15px;
}
.bg-wrap-color{
    padding: 0;
    background-color:#F1F4F9;
}
</style>